import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ModalProvider } from "../../utils/modalContext";
import ModalExample from "../ModalExample";
import CreateCampaignForm from "../CreateCampaignForm";
import MoveToFolderForm from "../MoveToFolderForm";
import CreateAdForm from "../CreateAdForm";
import {
  Button,
  Card,
  Checkbox,
  Tooltip,
  TextInput,
  FormGroup,
  Select,
} from "gumdrops";

export default function Home() {
  const [filter, setFilter] = useState(false);
  const [create, setCreate] = useState(false);
  const [bulkMenu, setBulkMenu] = useState(false);
  return (
    <div className="gds-layout__container">
      <div className="gds-flex gds-flex--justify-end -m-b-2">
        <ModalProvider>
          <div className="custom-menu-button ">
            <Button
              size="sm"
              context="primary"
              className="-m-l-2"
              onClick={() => setCreate(!create)}
            >
              Create <i class="fas fa-plus"></i>
            </Button>
            {create && (
              <Card
                style={{
                  position: "absolute",
                  top: 35,
                  right: 0,
                  zIndex: 100,
                  minWidth: 140,
                }}
              >
                <ModalExample
                  actionTitle="Create Folder"
                  size="xs"
                  context="link"
                  title="Create Folder"
                  content={<CreateCampaignForm />}
                />

                <ModalExample
                  actionTitle="Create Ad"
                  size="xs"
                  context="link"
                  title="Create Ad"
                  content={<CreateAdForm />}
                />
                <Link
                  to="/hype"
                  className="gds-button gds-button--xs gds-button--link"
                >
                  Hype Upload
                </Link>
              </Card>
            )}
          </div>
        </ModalProvider>
      </div>
      <div className="gds-flex -m-b-2">
        <div className="gds-flex__item">
          <FormGroup>
            <TextInput
              className=""
              name="name"
              onChange={() => console.log("text input")}
              placeholder="Search"
              size="sm"
              type="text"
            />
          </FormGroup>
        </div>
        <div className="gds-flex__item gds-flex__item--grow-0">
          <div className="custom-menu-button " style={{ position: "relative" }}>
            <Button
              size="sm"
              context="outline"
              className="-m-l-2"
              onClick={() => setFilter(!filter)}
            >
              Filter <i class="fas fa-filter"></i>
            </Button>
            {filter && (
              <Card
                style={{
                  position: "absolute",
                  display: "inline",
                  top: 35,
                  right: 0,
                  zIndex: 100,
                  minWidth: 100,
                }}
              >
                <Button context="link" size="xs">
                  See Ad Manager Filter Layout
                </Button>
              </Card>
            )}
          </div>
        </div>
      </div>

      <div className="gds-flex__item gds-button-group gds-button-group--xs -inline-block -m-r-2">
        <button
          className="gds-button-group__button gds-button--outline gds-button--xs -pointer-events--none"
          style={{ width: 50, height: 29 }}
          type="button"
        >
          <div className="gds-form-group">
            <div
              className="gds-form-group__checkbox gds-form-group__checkbox--sm"
              style={{ top: 1 }}
            >
              <label className="gds-form-group__checkbox-label -m-l-2">
                <input
                  type="checkbox"
                  className="gds-form-group__checkbox-input -pointer-events--auto"
                  name="In-Screen"
                  defaultValue="on"
                />
                <span className="gds-form-group__checkbox-indicator" />
              </label>
            </div>
          </div>
        </button>
        <button
          className="gds-button-group__button gds-button--outline gds-button--xs  -pointer-events--none"
          style={{ minWidth: "80px" }}
          type="button"
        >
          1 selected
        </button>
        <div
          className={`gds-button-dropdown gds-button-dropdown--sm gds-button-dropdown--in-group ${
            bulkMenu ? "gds-button-dropdown--active" : ""
          }`}
        >
          <button
            onClick={() => setBulkMenu(!bulkMenu)}
            className="gds-button-dropdown__button gds-button--primary gds-button--xs"
            type="button"
            style={{ width: "100px", zIndex: 0 }}
          >
            Action
          </button>
          <ul
            className="gds-button-dropdown__menu -color-bg-white"
            style={{ width: "200px" }}
          >
            <li className="gds-button-dropdown__menu-item">
              <ModalProvider>
                <ModalExample
                  actionTitle="Move to Folder"
                  size="xs"
                  context="link"
                  title="Move to Folder"
                  content={<MoveToFolderForm />}
                />
              </ModalProvider>
            </li>
          </ul>
        </div>
      </div>

      <div className="gds-container -color-bg-white -p-a-0 -color-bd-lt-2">
        <div className="gds-table--responsive gds-table--striped">
          <table className="gds-table gds-table--sm">
            <thead>
              <tr className="gds-table__row">
                <th
                  className="gds-table__header gds-table__header--white -text-left"
                  style={{ width: 30 }}
                ></th>
                <th
                  className="gds-table__header gds-table__header--white"
                  style={{ width: 30 }}
                ></th>
                <th className="gds-table__header gds-table__header--white -text-left">
                  Name
                </th>
                <th className="gds-table__header gds-table__header--white -text-left">
                  Type
                </th>
                <th
                  className="gds-table__header gds-table__header--white"
                  style={{ width: 50 }}
                >
                  Hype
                </th>
                <th
                  className="gds-table__header gds-table__header--white -text-left"
                  style={{ width: 80 }}
                >
                  Jira
                </th>
                <th
                  className="gds-table__header gds-table__header--white -text-left"
                  style={{ width: 70 }}
                >
                  # of Ads
                </th>

                <th className="gds-table__header gds-table__header--white -text-left">
                  Updated
                </th>
                <th className="gds-table__header gds-table__header--white -text-left">
                  User
                </th>
                <th
                  className="gds-table__header gds-table__header--white"
                  style={{ width: 180 }}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="gds-table__row">
                <td></td>
                <td className="-text-center">
                  <i class="fas fa-lg fa-folder"></i>
                </td>
                <td>
                  <Link to="/campaign" className="-color-tx-pri-dk-3">
                    Boost Mobile
                  </Link>
                </td>
                <td></td>
                <td></td>
                <td>
                  <Link to="/campaign" className="-color-tx-pri-dk-3">
                    DTR-5947
                  </Link>
                </td>

                <td>
                  <Link to="/campaign" className="-color-tx-pri-dk-3">
                    3
                  </Link>
                </td>
                <td>
                  <Link to="/campaign" className="-color-tx-pri-dk-3">
                    11/27/2020
                  </Link>
                </td>
                <td>
                  <Link to="/campaign" className="-color-tx-pri-dk-3">
                    Henry Nguyen
                  </Link>
                </td>
                <td>
                  <div className="gds-flex gds-flex--justify-start">
                    <Tooltip text="Folder Link" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-link" />
                      </button>
                    </Tooltip>
                    <Tooltip
                      text="Create ad assigned to this campaign"
                      position="left"
                    >
                      <button className="icon">
                        <i className="fas fa-sm fa-plus" />
                      </button>
                    </Tooltip>
                  </div>
                </td>
              </tr>
              <tr className="gds-table__row">
                <td>
                  <Checkbox size="sm" className="-m-l-2" />
                </td>
                <td className="-text-center">
                  <i class="fas fa-lg fa-image"></i>
                </td>
                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    Boost OLV Q4 2020
                  </Link>
                </td>
                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    In-Screen Animated
                  </Link>
                </td>
                <td className="-text-center">
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    <i className="fas fa-sm fa-check"></i>
                  </Link>
                </td>
                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3"></Link>
                </td>
                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    1
                  </Link>
                </td>
                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    11/27/2020
                  </Link>
                </td>
                <td>
                  <Link to="/ad" className="-color-tx-pri-dk-3">
                    Someone Else
                  </Link>
                </td>
                <td>
                  <div className="gds-flex gds-flex--justify-start">
                    <Tooltip text="Demo Link" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-link" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Mobile Demo Link" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-mobile-alt" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Download" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-download" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Copy Markup to Clipboard" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-clipboard" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Edit Name" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-edit"></i>
                      </button>
                    </Tooltip>
                    <Tooltip text="Clone" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-clone" />
                      </button>
                    </Tooltip>
                    <Tooltip text="Delete Unit" position="left">
                      <button className="icon">
                        <i className="fas fa-sm fa-trash" />
                      </button>
                    </Tooltip>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr className="-color-bd-lt-2 -m-a-0" />
          <div className="gds-flex gds-flex--align-center -p-a-2">
            <div className="gds-flex__item gds-flex__item--grow-1 gds-text--body-xs">
              317 results
            </div>
            <div className="gds-flex__item gds-flex__item--grow-2">
              <nav className="">
                <ul
                  className="gds-pagination gds-pagination--xs"
                  data-paganimate=""
                >
                  <li className="gds-pagination__page-item">
                    {" "}
                    <a
                      href="/"
                      className="gds-pagination__page-link"
                      aria-label="Previous"
                      data-page-change="prev"
                    >
                      {" "}
                      <span className="-vis-hidden" aria-hidden="true">
                        «
                      </span>{" "}
                      <span className="-sr-only">Previous</span>{" "}
                    </a>{" "}
                  </li>
                  <li
                    className="gds-pagination__page-item gds-pagination__page-item--active"
                    data-paginate-active="true"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      1
                    </a>
                  </li>
                  <li
                    className="gds-pagination__page-item"
                    data-paginate-active="false"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      2
                    </a>
                  </li>
                  <li
                    className="gds-pagination__page-item"
                    data-paginate-active="false"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      3
                    </a>
                  </li>
                  <li
                    className="gds-pagination__page-item"
                    data-paginate-active="false"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      4
                    </a>
                  </li>
                  <li
                    className="gds-pagination__page-item"
                    data-paginate-active="false"
                  >
                    <a href="/" className="gds-pagination__page-link">
                      5
                    </a>
                  </li>
                  <li className="gds-pagination__page-item">
                    <a
                      href="/"
                      className="gds-pagination__page-link"
                      aria-label="Next"
                      data-page-change="next"
                    >
                      <span className="-vis-hidden" aria-hidden="true">
                        »
                      </span>{" "}
                      <span className="-sr-only">Next</span>
                    </a>
                  </li>
                  <span className="gds-pagination__page-indicator" />
                </ul>
              </nav>
            </div>
            <div className="gds-flex__item gds-flex__item--grow-1 gds-flex gds-flex--justify-end">
              <Select
                options={[
                  {
                    name: "20",
                    value: "1",
                  },
                  {
                    name: "50",
                    value: "2",
                  },
                  {
                    name: "100",
                    value: "3",
                  },
                ]}
                size="xs"
                name="numItems"
                defaultValue="1"
                className=""
                style={{ maxWidth: "70px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <Tooltip text="Admin Settings" position="right">
        <Link
          to="/admin"
          className="-color-tx-lt-5 gds-text--regular gds-text--body-sm -p-a-1"
        >
          Admin
          <i className="fas fa-cog -m-l-1" />
        </Link>
      </Tooltip>
    </div>
  );
}
